import DgModal from "../../../custom/feedback/modal";
import Update from "./update";


const EditParent = ({id, name, visible, onCancel})=>{

    return (
        <DgModal visible={visible}
                  width={900}
                  onCancel={() => onCancel()}
                  title={name}
                  bodyStyle={{
                      minHeight: 100,
                      maxHeight: 600,
                      overflowY: "scroll",
                  }}
                  destroyOnClose={true}
                  okText={"Lưu"}>
            <Update id={id}  onCancel={()=>onCancel()} />
        </DgModal>
    )
}
export default EditParent
